"use client"

import React from "react"
import { TypeAnimation } from "react-type-animation"
import { useTranslation } from "react-i18next"
import { MagicTextAnimate } from "./magic-text/MagicTextAnimate"
import Image from 'next/image'

export function ChatLoader() {
  const { t } = useTranslation()

  return (
    <div className="flex flex-col items-center justify-center space-y-6">
      <div className="flex items-center justify-center gap-4">
        <Image
          src="/sarki-ai-logo-dark.svg"
          alt="PleromaAI Logo"
          width={64}
          height={64}
          className="h-24 w-24 sm:h-24 sm:w-24 opacity-80"
          priority
        />

        <div className="mt-[-6px] text-left">
          <MagicTextAnimate className="text-2xl sm:text-4xl font-bold">
            <TypeAnimation
              speed={90}
              cursor={true}
              wrapper="span"
              repeat={Infinity}
              sequence={[
                () => { },
                t('chat.welcome.fr'), 2500,
                t('chat.welcome.en'), 2500,
                t('chat.welcome.fl'), 2500,
              ]}
            />
          </MagicTextAnimate>
          <p className="text-xs sm:text-sm text-muted-foreground">
            {t('chat.emptyState.subtitle')}
          </p>
        </div>
      </div>


    </div>
  )
}
